import { postImage } from "@/api/DiaryApi";
import moment from 'moment';
import GlobalConstants from "@/store/constants/global"
import DashboardConstants from "@/store/constants/dashboardRecords"
import { generateUUID } from "@/services/GlobalServices"

export default {
  name: "SignatureModal",
  props: {},
  data() {
    return {
    }
  },
  mounted() {
    this.$root.$on('bv::modal::shown', (bvEvent) => {
      if (bvEvent.componentId == "signature-modal") {
        this.showOldData()
      }
    })
    this.$root.$on('bv::modal::hidden', (bvEvent) => {
      const signatureObj = this.$store.getters['dashboardRecords/getSignature'];
      if (bvEvent.componentId == "confirm-modal" && signatureObj.dataImage=="") {
        this.showOldData()
      }
    })
  },
  methods: {
    async saveSign() {
      try{
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
        const signatureObj = this.$store.getters['dashboardRecords/getSignature'];
        this.$bvModal.hide("signature-modal")
        if (!isEmpty) {
          const fileTypeObject = this.generateFileName()
          let blob = this.base64ToBlob(data, 'image/png');
          let bufferArraySignImage = await blob.arrayBuffer();
          const urlImage = await postImage(bufferArraySignImage, fileTypeObject)
          if (signatureObj.signFor == "SignHeader") {
            // objectKeyからファイル名を抽出
            const fileName = urlImage.objectKey ? urlImage.objectKey.split('/').pop() : '';
            this.$store.commit('dashboardRecords/setDataHeaderSigns', { attr: "name", order: signatureObj.order, value: fileName })
            this.$store.commit('dashboardRecords/setDataHeaderSigns', { attr: "presignedUrl", order: signatureObj.order, value: urlImage.presignedUrl })
            this.$store.commit('dashboardRecords/setDataHeaderSigns', { attr: "objectKey", order: signatureObj.order, value: urlImage.objectKey })
          } else if (signatureObj.signFor == "SignWorkRecord") {
            // objectKeyの値をそのまま使用（diary/image/${fileName}の形式を維持）
            this.$store.commit('dashboardRecords/setDataInputWorkModal', { attr: "sign", index: -1, value: urlImage.objectKey })
            this.$store.commit('dashboardRecords/setDataInputWorkModal', { attr: "presignedUrl", index: -1, value: urlImage.presignedUrl })
            this.$store.commit('dashboardRecords/setDataInputWorkModal', { attr: "objectKey", index: -1, value: urlImage.objectKey })
          } else if(signatureObj.signFor == "SignCommonInstructions"){
            const path = signatureObj.order;
            // objectKeyからファイル名を抽出
            const fileName = urlImage.objectKey ? urlImage.objectKey.split('/').pop() : '';
            this.$store.commit(DashboardConstants.COMMIT.setValueRecord, { path: "commons." + path, value: fileName });
            if(path == "supervisorPatrolRecord.supervisor"){
              this.$store.commit(DashboardConstants.COMMIT.setValueRecord, { path: "commons." + "supervisorPatrolRecord.supervisorPresignedUrl", value: urlImage.presignedUrl });
              this.$store.commit(DashboardConstants.COMMIT.setValueRecord, { path: "commons." + "supervisorPatrolRecord.supervisorObjectKey", value: urlImage.objectKey });
            }
            else if(path == "instructionDuringWork.instructor"){
              this.$store.commit(DashboardConstants.COMMIT.setValueRecord, { path: "commons." + "instructionDuringWork.instructorPresignedUrl", value: urlImage.presignedUrl });
              this.$store.commit(DashboardConstants.COMMIT.setValueRecord, { path: "commons." + "instructionDuringWork.instructorObjectKey", value: urlImage.objectKey });
            }
          }
        }
      }catch(error){
        // TODO: "SecurityError: Failed to execute 'toDataURL' on 'HTMLCanvasElement': Tainted canvases may not be exported.
        this.$bvModal.hide("signature-modal")
      }
    },
    base64ToBlob(base64, mime=''){
      let base64ImageContent = base64.replace(/^data:image\/(png|jpg);base64,/, "");
      const sliceSize = 1024;
      const byteChars = window.atob(base64ImageContent);
      const byteArrays = [];
      let  len = byteChars.length;
      for (let offset = 0;offset < len; offset += sliceSize) {
        let slice = byteChars.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }
      return new Blob(byteArrays, {type: mime});
    },
    generateFileName(){
      // ファイル名はそのままS3オブジェクトキー(diary/images/<fileName>)になる。
      // 以前は moment("hhmmssDDMMYYYY") のみ（12時間表記・秒精度）だったため、
      // 別現場・別日誌でも同一時分秒に署名すると同名キーへPUTされ、後勝ちで画像が
      // 上書きされて他現場のサインが表示される不具合があった。
      // 現場/日誌をまたいでも衝突しないよう、24時間表記＋ミリ秒＋UUIDで一意化する。
      let timeNowValue = moment().format("YYYYMMDDHHmmssSSS")
      let uniqueId = generateUUID()
      return {
        name: `sign-${timeNowValue}-${uniqueId}.png`,
        type: "image/png"
      };
    },
    deleteData() {
      this.$bvModal.show('confirm-modal')
      const signatureObj = this.$_.cloneDeep(this.$store.getters['dashboardRecords/getSignature']);
      const confirmObj = { attr: signatureObj.signFor, orderId: signatureObj.order }
      this.$store.commit(GlobalConstants.COMMIT.setConfirmAttr, confirmObj)
      try{
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
        if (!isEmpty) {
          this.$store.commit('dashboardRecords/setSignature', Object.assign(signatureObj, {
            dataImage: data,
          }))
        }
      }catch(errors){
        // TODO: "SecurityError: Failed to execute 'toDataURL' on 'HTMLCanvasElement': Tainted canvases may not be exported.
      }
      // this.$refs.signaturePad.openSignaturePad()
    },
    showOldData() {
      const signatureObj = this.$store.getters['dashboardRecords/getSignature'];
      if (signatureObj.dataImage != "" &&  this.$refs.signaturePad) {
        this.startSignature()
        this.toDataURL( signatureObj.dataImage, (image) => {
          this.$refs.signaturePad.fromDataURL(image)
        })
        // this.$refs.signaturePad.lockSignaturePad()
      } else if(this.$refs.signaturePad) {
        this.$refs.signaturePad.clearSignature();
      }
    },
    startSignature() {
      this.$refs.signaturePad.resizeCanvas();
    },
    toDataURL(url, callback){
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          callback(reader.result);
        }
        reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    },
  },
  computed: {
    statusEditable() {
      return this.$store.getters['dashboardRecords/getStatusEditable']
    },
  },
}
